import { render, staticRenderFns } from "./AttractivenessAnalysis.vue?vue&type=template&id=04f4027d&scoped=true&"
import script from "./AttractivenessAnalysis.vue?vue&type=script&lang=ts&"
export * from "./AttractivenessAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./AttractivenessAnalysis.vue?vue&type=style&index=0&id=04f4027d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4027d",
  null
  
)

export default component.exports